import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pwd216Api, PendingItem } from '../../../services/pwd216Api';

export interface UsePwd216QueryReturn {
  startNo: string;
  endNo: string;
  setStartNo: (v: string) => void;
  setEndNo: (v: string) => void;
  loading: boolean;
  items: PendingItem[];
  fetchPending: () => Promise<void>;
}

export function usePwd216Query(): UsePwd216QueryReturn {
  const [startNo, setStartNo] = useState('');
  const [endNo, setEndNo] = useState('');
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState<PendingItem[]>([]);

  const fetchPending = useCallback(async () => {
    setLoading(true);
    try {
      const resp = await pwd216Api.getPending(startNo, endNo);
      const data = resp.data || [];
      setItems(data);
      if (data.length === 0) {
        message.info('查無待核准資料');
      }
    } catch (err: unknown) {
      const msg = (err as any)?.response?.data?.error || (err instanceof Error ? err.message : '查詢失敗');
      message.error(msg);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [startNo, endNo]);

  return {
    startNo,
    endNo,
    setStartNo,
    setEndNo,
    loading,
    items,
    fetchPending,
  };
}
